module.exports = __webpack_public_path__ + "media/images/redesign-images/icons/icon-shipped-138d8932510f44ae7647ea6ddde04e26.svg";